document.addEventListener('DOMContentLoaded', function () {
  [].forEach.call(document.querySelectorAll('.carousel-banner'), function (el) {
    window.pingInit.initCarouselBanner(el);
  })
});

if (!window.pingInit) window.pingInit = {};
window.pingInit.initCarouselBanner = context => {
  const carousel_banner = context.closest('.shopify-section');

  if (carousel_banner) {
    const slider = context.querySelector('.carousel-blocks');
    const suffixId = slider.children[0] ? slider.children[0].id.split('---')[0] : '';
    carousel_banner.setAttribute('current-slide', 1);
    const icon_right = context.querySelector('.carousel-header .icon-chevron-right');
    const icon_left = context.querySelector('.carousel-header .icon-chevron-left');
    const slide_width = slider.children[0] ? slider.children[0].offsetWidth : -1;

    icon_left.addEventListener("click", function () {
      var slide = carousel_banner.getAttribute('current-slide');
      slide--;

      const scrollTo = document.getElementById(suffixId + '---' + slide);
      if (scrollTo) {
        $(slider).animate({scrollLeft: scrollTo.offsetLeft}, 600);
        carousel_banner.setAttribute('current-slide', slide);
      }
    });

    icon_right.addEventListener("click", function () {
      var slide = carousel_banner.getAttribute('current-slide');
      slide++;

      const scrollTo = document.getElementById(suffixId + '---' + slide);
      const max_slide = Math.ceil((slider.scrollWidth - slider.offsetWidth ) / slide_width) + 1;
      if (scrollTo && slide <= max_slide) {
        $(slider).animate({scrollLeft: scrollTo.offsetLeft}, 600);
        carousel_banner.setAttribute('current-slide', slide);
      }
    });

    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3; //scroll-fast
      slider.scrollLeft = scrollLeft - walk;

      // update number of current slide
      const currSlide = carousel_banner.getAttribute('current-slide');
      const max_slide = Math.ceil((slider.scrollWidth - slider.offsetWidth ) / slide_width) + 1;
      const newSlide = Math.ceil(slider.scrollLeft / slide_width) + 1; // number of slide start from 1
      if (newSlide != currSlide && newSlide <= max_slide) {
        carousel_banner.setAttribute('current-slide', newSlide);
      }
    });
  }
}
